import React from 'react'

import UserGroupRestrictionsList from './UserGroupRestrictionsList'

const UserGroupRestrictions = ({ settings, setSettings }) => {
    return (
        <div data-testid={`customer-group-restriction-section`}>
            <label className="!mt-2">User Group Restrictions</label>

            <UserGroupRestrictionsList settings={settings} setSettings={setSettings} />
        </div>
    )
}

export default UserGroupRestrictions
